import * as React from 'react'
import Icon from '../Icon/Icon'

const Landscape = () => {
  return (
    <div className="Landscape">
      <div className="Landscape-wrapper">
        <p className="Landscape-title">Retournez votre téléphone</p>
        <p className="Landscape-subtitle">
          Veuillez tourner votre téléphone pour une meilleure expérience
        </p>
        <Icon name="smartphone" />
      </div>
    </div>
  )
}

export default Landscape



// WEBPACK FOOTER //
// ./src/components/Landscape/Landscape.tsx